import {GridSortDirection} from '@mui/x-data-grid-pro';

export const directoryComparator = (
   v1: string,
   v2: string,
   isDirectory1: boolean,
   isDirectory2: boolean,
   sortOrder: GridSortDirection,
   upfolderName?: string
) => {
   const reverseKoef = sortOrder === 'asc' ? 1 : -1;
   if (v1 === upfolderName) {
      return -1 * reverseKoef;
   } else if (v2 === upfolderName) {
      return 1 * reverseKoef;
   }

   if (isDirectory1 !== isDirectory2) {
      const r = Number(isDirectory2) - Number(isDirectory1); //directoryPriorityComparator(v1, v2, isDirectory1, isDirectory2, upfolderName);
      return r * reverseKoef;
   }

   return String(v1).localeCompare(String(v2));
};
